import type { PreviewEmail } from "../../types/preview";
import { verifiedChannelsText } from "../../lib/registry";
import { CopyButton } from "../shared/CopyButton";

export function CopyChannelsButton({ emails, tone = "dark" }: { emails: PreviewEmail[]; tone?: "dark" | "light" }) {
  const text = verifiedChannelsText(emails);
  if (!text) return null;
  return <CopyButton text={text} label="Copiar canais de notificação" copiedLabel="Canais copiados!" testId="copy-channels-button" tone={tone} compact />;
}
